import axios from 'axios'
import qs from 'qs'
let baseURL = 'https://www.gaokaowin.com';
sessionStorage.url = baseURL;
export function request(config) {
    //sessionStorage.setItem('url', 'https://www.gaokaowin.com')
    const instance = axios.create({
        baseURL: baseURL,
        timeout: 30000,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        }
    })

    instance.interceptors.request.use(config => {
        config.data = qs.stringify(config.data)
        console.log(config)
            // let url = config.url
        return config
    }, err => {

        return err
    })

    instance.interceptors.response.use(response => {

        return response.data
    }, err => {

        return err
    })


    return instance(config)
}